import { DownloadFileAPI } from '../../../api/files/DownloadFileAPI';

export class DownloadCommand {
    constructor() {
        this.downloadFileApi = new DownloadFileAPI();
    }

    downloadBusSched(name, providerId = '', successCallback = undefined, errorCallback = undefined) {
        const apiResult = this.downloadFileApi.downloadBusSched(name, providerId);
        apiResult.then(async (result) => {
            if (undefined !== successCallback) {
                successCallback(await result.blob());
            }
        }).catch(() => {
            if (undefined !== errorCallback) {
                errorCallback("Ocorreu um erro a transferir o ficheiro.");
            }
        });
    }

    downloadMultipleBusSched(documents, providerId = '', networkId = '', successCallback = undefined, errorCallback = undefined) {
        const apiResult = this.downloadFileApi.downloadMultipleBusSched(documents, providerId, networkId);
        apiResult.then(async (result) => {
            if (undefined !== successCallback) {
                successCallback(await result.blob());
            }
        }).catch(() => {
            if (undefined !== errorCallback) {
                errorCallback("Ocorreu um erro a transferir o ficheiro.");
            }
        });
    }

    downloadBusmap(isTransportAuthorityData, name, providerId = '', successCallback, errorCallback) {
        let apiResult = undefined;
        if (isTransportAuthorityData) {
            apiResult = this.downloadFileApi.downloadBusmapTransportAuthority(name);
        }
        else {
            apiResult = this.downloadFileApi.downloadBusmap(name, providerId);
        }

        apiResult.then(async (result) => {
            if (undefined !== successCallback) {
                successCallback(await result.blob());
            }
        }).catch(() => {
            if (undefined !== errorCallback) {
                errorCallback("Ocorreu um erro a transferir o ficheiro.");
            }
        });
    }

    downloadExportedDocument(name, providerId = '', successCallback, errorCallback) {
        const apiResult = this.downloadFileApi.downloadExportedDocument(name, providerId);
        apiResult.then(async (result) => {
            if (undefined !== successCallback) {
                successCallback(await result.blob());
            }
        }).catch(() => {
            if (undefined !== errorCallback) {
                errorCallback("Ocorreu um erro a transferir o ficheiro.");
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/components/files/commands/DownloadCommand.js